import { Component, Input, OnInit } from '@angular/core';
import { ErrorTranslationService } from '@bayclubs/utils';
import { camps } from '../../../../../../models/models.generated';

@Component({
    selector: 'app-camp-care-days-generator-summary',
    templateUrl: './camp-care-days-generator-summary.component.html',
    styleUrls: ['./camp-care-days-generator-summary.component.scss'],
    standalone: false
})
export class CampCareDaysGeneratorSummaryComponent implements OnInit {

    @Input()
    public summary: camps.CampCareDaysGenerationResult;

    constructor(private errorTranslator: ErrorTranslationService) {
    }

    ngOnInit(): void {
    }

    public getErrors() {
        return this.summary.failes.map(x => x.errors).reduce((a, b) => a.concat(b), []);
    }

    public translateError(key: string) : string{
        var msg = this.errorTranslator.translateErrorByKey("Camps", key);
        if(msg) return msg;
        
        return key;
    }
}
